var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c("div", {}, [
      _vm._m(0),
      _c("div", { staticClass: "bullshit" }, [
        _c("div", {}, [_vm._v("OOPS!")]),
        _vm._m(1),
        _c("div", {}, [_vm._v(_vm._s(_vm.message))]),
        _c("div", {}, [
          _vm._v(
            "请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告"
          ),
        ]),
        _c("a", { attrs: { href: "/" } }, [_vm._v("返回首页")]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pic-404" }, [
      _c("img", {
        attrs: { src: require("@/assets/404_images/404.png"), alt: "404" },
      }),
      _c("img", {
        staticClass: "left",
        attrs: {
          src: require("@/assets/404_images/404_cloud.png"),
          alt: "404",
        },
      }),
      _c("img", {
        staticClass: "mid",
        attrs: {
          src: require("@/assets/404_images/404_cloud.png"),
          alt: "404",
        },
      }),
      _c("img", {
        staticClass: "right",
        attrs: {
          src: require("@/assets/404_images/404_cloud.png"),
          alt: "404",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", {}, [
      _vm._v(" 版权所有 "),
      _c(
        "a",
        { attrs: { href: "https://wallstreetcn.com", target: "_blank" } },
        [_vm._v("华尔街见闻")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }